import { dictionaryApi } from './dictionaryClient';

export type DictionaryNotification = {
  id: number;
  subantaId?: number | null;
  tingantaId?: number | null;
  email: string;
  phone: string;
  comment: string;
  resolved: boolean;
};

export type CreateNotificationBody =
  | {
      subantaId: number;
      email: string;
      phone: string;
      comment: string;
      resolved?: boolean;
    }
  | {
      tingantaId: number;
      email: string;
      phone: string;
      comment: string;
      resolved?: boolean;
    };

export type PatchNotificationBody = Partial<
  Pick<DictionaryNotification, 'email' | 'phone' | 'comment' | 'resolved'>
>;

function normalizeList(data: unknown): DictionaryNotification[] {
  if (Array.isArray(data)) return data as DictionaryNotification[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: DictionaryNotification[] }).data;
  }
  return [];
}

export function isDictionaryNotification(x: unknown): x is DictionaryNotification {
  if (!x || typeof x !== 'object') return false;
  const o = x as Record<string, unknown>;
  return (
    typeof o.id === 'number' &&
    typeof o.email === 'string' &&
    typeof o.phone === 'string' &&
    typeof o.comment === 'string' &&
    typeof o.resolved === 'boolean'
  );
}

export function parseDictionaryNotifications(raw: unknown[] | undefined): DictionaryNotification[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter(isDictionaryNotification);
}

export async function listNotifications(): Promise<DictionaryNotification[]> {
  const res = await dictionaryApi.get<unknown>('/notifications');
  return normalizeList(res.data);
}

export async function getNotification(id: number): Promise<DictionaryNotification> {
  const res = await dictionaryApi.get<DictionaryNotification>(`/notifications/${id}`);
  return res.data;
}

export async function createNotification(
  body: CreateNotificationBody
): Promise<DictionaryNotification> {
  const res = await dictionaryApi.post<DictionaryNotification>('/notifications', body);
  return res.data;
}

export async function updateNotification(
  id: number,
  body: PatchNotificationBody
): Promise<DictionaryNotification> {
  const res = await dictionaryApi.patch<DictionaryNotification>(`/notifications/${id}`, body);
  return res.data;
}

export async function deleteNotification(id: number): Promise<void> {
  await dictionaryApi.delete(`/notifications/${id}`);
}

export function notificationBelongsToEntry(
  n: DictionaryNotification,
  variant: 'subanta' | 'tinganta',
  parentId: number
): boolean {
  if (variant === 'subanta') return n.subantaId === parentId;
  return n.tingantaId === parentId;
}
